// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AddTweetApiProjectItemsTwitterAddPostData, AddTweetApiProjectItemsTwitterAddPostErrors, AddTweetApiProjectItemsTwitterAddPostResponses, BulkAddAssignmentApiAnnotationsConfigScopesBulkAddPutData, BulkAddAssignmentApiAnnotationsConfigScopesBulkAddPutErrors, BulkAddAssignmentApiAnnotationsConfigScopesBulkAddPutResponses, ClearEmptyAssignmentsApiAnnotationsConfigScopesClearSchemeIdPostData, ClearEmptyAssignmentsApiAnnotationsConfigScopesClearSchemeIdPostErrors, ClearEmptyAssignmentsApiAnnotationsConfigScopesClearSchemeIdPostResponses, CountProjectItemsApiProjectItemsCountGetData, CountProjectItemsApiProjectItemsCountGetErrors, CountProjectItemsApiProjectItemsCountGetResponses, CreateProjectApiProjectsCreatePutData, CreateProjectApiProjectsCreatePutErrors, CreateProjectApiProjectsCreatePutResponses, DbTestApiPingDatabaseGetData, DbTestApiPingDatabaseGetResponses, DeleteImportDetailsApiImportsImportDeleteImportIdDeleteData, DeleteImportDetailsApiImportsImportDeleteImportIdDeleteErrors, DeleteImportDetailsApiImportsImportDeleteImportIdDeleteResponses, DeleteSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetaIdDeleteData, DeleteSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetaIdDeleteErrors, DeleteSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetaIdDeleteResponses, DeleteTaskApiPipesTaskDeleteData, DeleteTaskApiPipesTaskDeleteErrors, DeleteTaskApiPipesTaskDeleteResponses, DropPrioSetupApiPrioSetupDeleteData, DropPrioSetupApiPrioSetupDeleteErrors, DropPrioSetupApiPrioSetupDeleteResponses, EditAssignmentApiAnnotationsConfigAssignmentsEditPutData, EditAssignmentApiAnnotationsConfigAssignmentsEditPutErrors, EditAssignmentApiAnnotationsConfigAssignmentsEditPutResponses, EmitApiEventsEmitPostData, EmitApiEventsEmitPostErrors, EmitApiEventsEmitPostResponses, ErrApiPingErrorGetData, ErrApiPingErrorGetResponses, GetAllImportsForProjectApiImportsListGetData, GetAllImportsForProjectApiImportsListGetErrors, GetAllImportsForProjectApiImportsListGetResponses, GetAllProjectPermissionsApiProjectPermissionsListProjectIdGetData, GetAllProjectPermissionsApiProjectPermissionsListProjectIdGetErrors, GetAllProjectPermissionsApiProjectPermissionsListProjectIdGetResponses, GetAllProjectsApiProjectsListGetData, GetAllProjectsApiProjectsListGetResponses, GetAllUserPermissionsApiProjectPermissionsListUsersGetData, GetAllUserPermissionsApiProjectPermissionsListUsersGetErrors, GetAllUserPermissionsApiProjectPermissionsListUsersGetResponses, GetAllUsersApiUsersListAllGetData, GetAllUsersApiUsersListAllGetResponses, GetAllUsersDehydratedApiUsersListAllDehydratedGetData, GetAllUsersDehydratedApiUsersListAllDehydratedGetResponses, GetAnnotationsApiAnnotationsAnnotateAnnotationsAssignmentScopeIdGetData, GetAnnotationsApiAnnotationsAnnotateAnnotationsAssignmentScopeIdGetErrors, GetAnnotationsApiAnnotationsAnnotateAnnotationsAssignmentScopeIdGetResponses, GetAnnotationSchemeFingerprintsApiAnnotationsSchemesFingerprintsGetData, GetAnnotationSchemeFingerprintsApiAnnotationsSchemesFingerprintsGetErrors, GetAnnotationSchemeFingerprintsApiAnnotationsSchemesFingerprintsGetResponses, GetAnnotationsCsvApiExportAnnotationsCsvPostData, GetAnnotationsCsvApiExportAnnotationsCsvPostErrors, GetAnnotationsCsvApiExportAnnotationsCsvPostResponses, GetAnnotatorRankingApiStatsRankGetData, GetAnnotatorRankingApiStatsRankGetErrors, GetAnnotatorRankingApiStatsRankGetResponses, GetAnnotatorsForSchemeApiAnnotationsConfigAnnotatorsSchemeIdGetData, GetAnnotatorsForSchemeApiAnnotationsConfigAnnotatorsSchemeIdGetErrors, GetAnnotatorsForSchemeApiAnnotationsConfigAnnotatorsSchemeIdGetResponses, GetArchiveApiPipesArtefactsFilesGetData, GetArchiveApiPipesArtefactsFilesGetErrors, GetArchiveApiPipesArtefactsFilesGetResponses, GetArtefactsApiPipesArtefactsListGetData, GetArtefactsApiPipesArtefactsListGetErrors, GetArtefactsApiPipesArtefactsListGetResponses, GetArtefactsApiPrioArtefactsListGetData, GetArtefactsApiPrioArtefactsListGetErrors, GetArtefactsApiPrioArtefactsListGetResponses, GetAssignmentApiAnnotationsAnnotateAssignmentAssignmentIdGetData, GetAssignmentApiAnnotationsAnnotateAssignmentAssignmentIdGetErrors, GetAssignmentApiAnnotationsAnnotateAssignmentAssignmentIdGetResponses, GetAssignmentIndicatorsForScopeApiAnnotationsAnnotateAssignmentProgressAssignmentScopeIdGetData, GetAssignmentIndicatorsForScopeApiAnnotationsAnnotateAssignmentProgressAssignmentScopeIdGetErrors, GetAssignmentIndicatorsForScopeApiAnnotationsAnnotateAssignmentProgressAssignmentScopeIdGetResponses, GetAssignmentsApiAnnotationsAnnotateAssignmentsAssignmentScopeIdGetData, GetAssignmentsApiAnnotationsAnnotateAssignmentsAssignmentScopeIdGetErrors, GetAssignmentsApiAnnotationsAnnotateAssignmentsAssignmentScopeIdGetResponses, GetAssignmentScopeApiAnnotationsAssignmentsScopeAssignmentScopeIdGetData, GetAssignmentScopeApiAnnotationsAssignmentsScopeAssignmentScopeIdGetErrors, GetAssignmentScopeApiAnnotationsAssignmentsScopeAssignmentScopeIdGetResponses, GetAssignmentScopesForProjectApiAnnotationsAssignmentsScopesGetData, GetAssignmentScopesForProjectApiAnnotationsAssignmentsScopesGetErrors, GetAssignmentScopesForProjectApiAnnotationsAssignmentsScopesGetResponses, GetAssignmentScopesForSchemeApiAnnotationsConfigScopesSchemeIdGetData, GetAssignmentScopesForSchemeApiAnnotationsConfigScopesSchemeIdGetErrors, GetAssignmentScopesForSchemeApiAnnotationsConfigScopesSchemeIdGetResponses, GetAssignmentScopesForUserApiAnnotationsAssignmentsScopesProjectIdGetData, GetAssignmentScopesForUserApiAnnotationsAssignmentsScopesProjectIdGetErrors, GetAssignmentScopesForUserApiAnnotationsAssignmentsScopesProjectIdGetResponses, GetAssignmentsForScopeApiAnnotationsAnnotateAssignmentsScopeAssignmentScopeIdGetData, GetAssignmentsForScopeApiAnnotationsAnnotateAssignmentsScopeAssignmentScopeIdGetErrors, GetAssignmentsForScopeApiAnnotationsAnnotateAssignmentsScopeAssignmentScopeIdGetResponses, GetBasicStatsApiStatsBasicsGetData, GetBasicStatsApiStatsBasicsGetErrors, GetBasicStatsApiStatsBasicsGetResponses, GetBotAnnotationsApiAnnotationsBotAnnotationsGetData, GetBotAnnotationsApiAnnotationsBotAnnotationsGetErrors, GetBotAnnotationsApiAnnotationsBotAnnotationsGetResponses, GetBotScopesApiAnnotationsBotScopesGetData, GetBotScopesApiAnnotationsBotScopesGetErrors, GetBotScopesApiAnnotationsBotScopesGetResponses, GetDetailForItemApiProjectItemsDetailItemIdGetData, GetDetailForItemApiProjectItemsDetailItemIdGetErrors, GetDetailForItemApiProjectItemsDetailItemIdGetResponses, GetExportBaseinfoApiExportProjectBaseinfoGetData, GetExportBaseinfoApiExportProjectBaseinfoGetErrors, GetExportBaseinfoApiExportProjectBaseinfoGetResponses, GetFileApiPipesArtefactsFileGetData, GetFileApiPipesArtefactsFileGetErrors, GetFileApiPipesArtefactsFileGetResponses, GetFileApiPrioArtefactsFileGetData, GetFileApiPrioArtefactsFileGetErrors, GetFileApiPrioArtefactsFileGetResponses, GetHighlighterApiHighlightersHighlighterIdGetData, GetHighlighterApiHighlightersHighlighterIdGetErrors, GetHighlighterApiHighlightersHighlighterIdGetResponses, GetImportCountsApiImportsImportImportIdCountGetData, GetImportCountsApiImportsImportImportIdCountGetErrors, GetImportCountsApiImportsImportImportIdCountGetResponses, GetImportDetailsApiImportsImportImportIdGetData, GetImportDetailsApiImportsImportImportIdGetErrors, GetImportDetailsApiImportsImportImportIdGetResponses, GetImportRevisionsApiImportsImportImportIdRevisionsGetData, GetImportRevisionsApiImportsImportImportIdRevisionsGetErrors, GetImportRevisionsApiImportsImportImportIdRevisionsGetResponses, GetIrrApiEvalQualityLoadAssignmentScopeIdGetData, GetIrrApiEvalQualityLoadAssignmentScopeIdGetErrors, GetIrrApiEvalQualityLoadAssignmentScopeIdGetResponses, GetItemInfoApiItemInfoItemIdGetData, GetItemInfoApiItemInfoItemIdGetErrors, GetItemInfoApiItemInfoItemIdGetResponses, GetItemLabelsApiItemLabelsItemIdGetData, GetItemLabelsApiItemLabelsItemIdGetErrors, GetItemLabelsApiItemLabelsItemIdGetResponses, GetItemM2MsApiItemM2MsItemIdGetData, GetItemM2MsApiItemM2MsItemIdGetErrors, GetItemM2MsApiItemM2MsItemIdGetResponses, GetItemsWithCountApiAnnotationsConfigItemsGetData, GetItemsWithCountApiAnnotationsConfigItemsGetErrors, GetItemsWithCountApiAnnotationsConfigItemsGetResponses, GetItemVariantsApiItemVariantsItemIdGetData, GetItemVariantsApiItemVariantsItemIdGetErrors, GetItemVariantsApiItemVariantsItemIdGetResponses, GetNextAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdCurrentAssignmentIdGetData, GetNextAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdCurrentAssignmentIdGetErrors, GetNextAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdCurrentAssignmentIdGetResponses, GetNextOpenAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdGetData, GetNextOpenAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdGetErrors, GetNextOpenAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdGetResponses, GetNumAssignmentsForScopeApiAnnotationsAnnotateScopeCountsAssignmentScopeIdGetData, GetNumAssignmentsForScopeApiAnnotationsAnnotateScopeCountsAssignmentScopeIdGetErrors, GetNumAssignmentsForScopeApiAnnotationsAnnotateScopeCountsAssignmentScopeIdGetResponses, GetProjectAnnotatorUsersApiUsersListProjectAnnotatorsProjectIdGetData, GetProjectAnnotatorUsersApiUsersListProjectAnnotatorsProjectIdGetErrors, GetProjectAnnotatorUsersApiUsersListProjectAnnotatorsProjectIdGetResponses, GetProjectApiProjectInfoGetData, GetProjectApiProjectInfoGetErrors, GetProjectApiProjectInfoGetResponses, GetProjectHighlightersApiHighlightersProjectGetData, GetProjectHighlightersApiHighlightersProjectGetErrors, GetProjectHighlightersApiHighlightersProjectGetResponses, GetProjectImportsApiImportsListDetailsGetData, GetProjectImportsApiImportsListDetailsGetErrors, GetProjectImportsApiImportsListDetailsGetResponses, GetProjectPermissionsByIdApiProjectPermissionsProjectPermissionIdGetData, GetProjectPermissionsByIdApiProjectPermissionsProjectPermissionIdGetErrors, GetProjectPermissionsByIdApiProjectPermissionsProjectPermissionIdGetResponses, GetProjectPermissionsCurrentUserApiProjectPermissionsMeGetData, GetProjectPermissionsCurrentUserApiProjectPermissionsMeGetErrors, GetProjectPermissionsCurrentUserApiProjectPermissionsMeGetResponses, GetProjectScopesApiEvalTrackingScopesGetData, GetProjectScopesApiEvalTrackingScopesGetErrors, GetProjectScopesApiEvalTrackingScopesGetResponses, GetProjectTrackersApiEvalTrackingTrackersGetData, GetProjectTrackersApiEvalTrackingTrackersGetErrors, GetProjectTrackersApiEvalTrackingTrackersGetResponses, GetProjectUsersApiUsersListProjectProjectIdGetData, GetProjectUsersApiUsersListProjectProjectIdGetErrors, GetProjectUsersApiUsersListProjectProjectIdGetResponses, GetPublicationYearHistogramApiStatsHistogramYearsGetData, GetPublicationYearHistogramApiStatsHistogramYearsGetErrors, GetPublicationYearHistogramApiStatsHistogramYearsGetResponses, GetResolutionsForScopeApiEvalResolutionsGetData, GetResolutionsForScopeApiEvalResolutionsGetErrors, GetResolutionsForScopeApiEvalResolutionsGetResponses, GetResolvedAnnotationsApiAnnotationsConfigResolvePostData, GetResolvedAnnotationsApiAnnotationsConfigResolvePostErrors, GetResolvedAnnotationsApiAnnotationsConfigResolvePostResponses, GetSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetadataIdGetData, GetSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetadataIdGetErrors, GetSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetadataIdGetResponses, GetSchemeDefinitionApiAnnotationsSchemesDefinitionAnnotationSchemeIdGetData, GetSchemeDefinitionApiAnnotationsSchemesDefinitionAnnotationSchemeIdGetErrors, GetSchemeDefinitionApiAnnotationsSchemesDefinitionAnnotationSchemeIdGetResponses, GetSchemeDefinitionsForProjectApiAnnotationsSchemesListGetData, GetSchemeDefinitionsForProjectApiAnnotationsSchemesListGetErrors, GetSchemeDefinitionsForProjectApiAnnotationsSchemesListGetResponses, GetTableSampleApiPrioTablePeekPostData, GetTableSampleApiPrioTablePeekPostErrors, GetTableSampleApiPrioTablePeekPostResponses, GetTableSampleHtmlApiPrioTablePeekHtmlPostData, GetTableSampleHtmlApiPrioTablePeekHtmlPostErrors, GetTableSampleHtmlApiPrioTablePeekHtmlPostResponses, GetTaskApiPipesTaskGetData, GetTaskApiPipesTaskGetErrors, GetTaskApiPipesTaskGetResponses, GetTaskLogApiPipesArtefactsLogGetData, GetTaskLogApiPipesArtefactsLogGetErrors, GetTaskLogApiPipesArtefactsLogGetResponses, GetTextForItemApiProjectItemsTextItemIdGetData, GetTextForItemApiProjectItemsTextItemIdGetErrors, GetTextForItemApiProjectItemsTextItemIdGetResponses, GetTrackerApiEvalTrackingTrackerTrackerIdGetData, GetTrackerApiEvalTrackingTrackerTrackerIdGetErrors, GetTrackerApiEvalTrackingTrackerTrackerIdGetResponses, GetUserByIdApiUsersDetailsUserIdGetData, GetUserByIdApiUsersDetailsUserIdGetErrors, GetUserByIdApiUsersDetailsUserIdGetResponses, GetUsersByIdsApiUsersDetailsGetData, GetUsersByIdsApiUsersDetailsGetErrors, GetUsersByIdsApiUsersDetailsGetResponses, LabelStatsApiStatsLabelsHumanPostData, LabelStatsApiStatsLabelsHumanPostErrors, LabelStatsApiStatsLabelsHumanPostResponses, LabelStatsApiStatsLabelsResolvedPostData, LabelStatsApiStatsLabelsResolvedPostErrors, LabelStatsApiStatsLabelsResolvedPostResponses, ListProjectDataApiProjectItemsItemTypeListGetData, ListProjectDataApiProjectItemsItemTypeListGetErrors, ListProjectDataApiProjectItemsItemTypeListGetResponses, ListProjectDataPagedApiProjectItemsItemTypeListPagePageSizeGetData, ListProjectDataPagedApiProjectItemsItemTypeListPagePageSizeGetErrors, ListProjectDataPagedApiProjectItemsItemTypeListPagePageSizeGetResponses, ListSavedResolvedAnnotationsApiAnnotationsConfigResolvedListGetData, ListSavedResolvedAnnotationsApiAnnotationsConfigResolvedListGetErrors, ListSavedResolvedAnnotationsApiAnnotationsConfigResolvedListGetResponses, LoginForAccessTokenApiLoginTokenPostData, LoginForAccessTokenApiLoginTokenPostErrors, LoginForAccessTokenApiLoginTokenPostResponses, LogoutApiLoginLogoutGetData, LogoutApiLoginLogoutGetResponses, MakeAssignmentsApiAnnotationsConfigAssignmentsAssignmentScopeIdPutData, MakeAssignmentsApiAnnotationsConfigAssignmentsAssignmentScopeIdPutErrors, MakeAssignmentsApiAnnotationsConfigAssignmentsAssignmentScopeIdPutResponses, NewsMailApiMailNewsPostData, NewsMailApiMailNewsPostErrors, NewsMailApiMailNewsPostResponses, NqlQueryApiSearchNqlQueryPostData, NqlQueryApiSearchNqlQueryPostErrors, NqlQueryApiSearchNqlQueryPostResponses, NqlQueryCountApiSearchNqlCountPostData, NqlQueryCountApiSearchNqlCountPostErrors, NqlQueryCountApiSearchNqlCountPostResponses, PermApiPingPermissionGetData, PermApiPingPermissionGetResponses, PingApiPingNamePostData, PingApiPingNamePostErrors, PingApiPingNamePostResponses, PongApiPingGetData, PongApiPingGetResponses, PutAnnotationSchemeApiAnnotationsSchemesDefinitionPutData, PutAnnotationSchemeApiAnnotationsSchemesDefinitionPutErrors, PutAnnotationSchemeApiAnnotationsSchemesDefinitionPutResponses, PutAssignmentScopeApiAnnotationsAssignmentsScopePutData, PutAssignmentScopeApiAnnotationsAssignmentsScopePutErrors, PutAssignmentScopeApiAnnotationsAssignmentsScopePutResponses, PutImportDetailsApiImportsImportPutData, PutImportDetailsApiImportsImportPutErrors, PutImportDetailsApiImportsImportPutResponses, ReadPrioSetupApiPrioSetupGetData, ReadPrioSetupApiPrioSetupGetErrors, ReadPrioSetupApiPrioSetupGetResponses, ReadProjectSetupsApiPrioSetupsGetData, ReadProjectSetupsApiPrioSetupsGetErrors, ReadProjectSetupsApiPrioSetupsGetResponses, ReadTokensMeApiLoginMyTokensGetData, ReadTokensMeApiLoginMyTokensGetResponses, ReadUsersMeApiLoginMeGetData, ReadUsersMeApiLoginMeGetResponses, RecomputeIrrApiEvalQualityComputeGetData, RecomputeIrrApiEvalQualityComputeGetErrors, RecomputeIrrApiEvalQualityComputeGetResponses, RefreshTokenApiLoginTokenTokenIdPutData, RefreshTokenApiLoginTokenTokenIdPutErrors, RefreshTokenApiLoginTokenTokenIdPutResponses, RemindUsersAssigmentApiMailAssignmentReminderPostData, RemindUsersAssigmentApiMailAssignmentReminderPostErrors, RemindUsersAssigmentApiMailAssignmentReminderPostResponses, RemoveAnnotationSchemeApiAnnotationsSchemesDefinitionSchemeIdDeleteData, RemoveAnnotationSchemeApiAnnotationsSchemesDefinitionSchemeIdDeleteErrors, RemoveAnnotationSchemeApiAnnotationsSchemesDefinitionSchemeIdDeleteResponses, RemoveAssignmentScopeApiAnnotationsAnnotateScopeAssignmentScopeIdDeleteData, RemoveAssignmentScopeApiAnnotationsAnnotateScopeAssignmentScopeIdDeleteErrors, RemoveAssignmentScopeApiAnnotationsAnnotateScopeAssignmentScopeIdDeleteResponses, RemoveProjectPermissionApiProjectPermissionsPermissionDeleteData, RemoveProjectPermissionApiProjectPermissionsPermissionDeleteErrors, RemoveProjectPermissionApiProjectPermissionsPermissionDeleteResponses, ResetImportMutexApiProjectImportMutexPutData, ResetImportMutexApiProjectImportMutexPutErrors, ResetImportMutexApiProjectImportMutexPutResponses, ResetPasswordApiMailResetPasswordUsernamePostData, ResetPasswordApiMailResetPasswordUsernamePostErrors, ResetPasswordApiMailResetPasswordUsernamePostResponses, RevokeTokenApiLoginTokenTokenIdDeleteData, RevokeTokenApiLoginTokenTokenIdDeleteErrors, RevokeTokenApiLoginTokenTokenIdDeleteResponses, SaveAnnotationApiAnnotationsAnnotateSavePostData, SaveAnnotationApiAnnotationsAnnotateSavePostErrors, SaveAnnotationApiAnnotationsAnnotateSavePostResponses, SavePrioSetupApiPrioSetupPutData, SavePrioSetupApiPrioSetupPutErrors, SavePrioSetupApiPrioSetupPutResponses, SaveProjectApiProjectInfoPutData, SaveProjectApiProjectInfoPutErrors, SaveProjectApiProjectInfoPutResponses, SaveProjectPermissionApiProjectPermissionsPermissionPutData, SaveProjectPermissionApiProjectPermissionsPermissionPutErrors, SaveProjectPermissionApiProjectPermissionsPermissionPutResponses, SaveResolvedAnnotationsApiAnnotationsConfigResolvePutData, SaveResolvedAnnotationsApiAnnotationsConfigResolvePutErrors, SaveResolvedAnnotationsApiAnnotationsConfigResolvePutResponses, SaveTrackerApiEvalTrackingTrackerPutData, SaveTrackerApiEvalTrackingTrackerPutErrors, SaveTrackerApiEvalTrackingTrackerPutResponses, SaveUserApiUsersDetailsPutData, SaveUserApiUsersDetailsPutErrors, SaveUserApiUsersDetailsPutResponses, SaveUserSelfApiUsersMyDetailsPutData, SaveUserSelfApiUsersMyDetailsPutErrors, SaveUserSelfApiUsersMyDetailsPutResponses, SearchOpenalexApiSearchOpenalexSelectPostData, SearchOpenalexApiSearchOpenalexSelectPostErrors, SearchOpenalexApiSearchOpenalexSelectPostResponses, SearchTasksApiPipesTasksGetData, SearchTasksApiPipesTasksGetErrors, SearchTasksApiPipesTasksGetResponses, StreamTaskLogApiPipesArtefactsLogStreamGetData, StreamTaskLogApiPipesArtefactsLogStreamGetErrors, StreamTaskLogApiPipesArtefactsLogStreamGetResponses, TaskApiPingSleepTaskGetData, TaskApiPingSleepTaskGetErrors, TaskApiPingSleepTaskGetResponses, TermExpansionApiSearchOpenalexTermsGetData, TermExpansionApiSearchOpenalexTermsGetErrors, TermExpansionApiSearchOpenalexTermsGetResponses, TerminateTaskApiPipesDramatiqTaskDeleteData, TerminateTaskApiPipesDramatiqTaskDeleteErrors, TerminateTaskApiPipesDramatiqTaskDeleteResponses, TrackedTaskApiPingTrackedSleepTaskGetData, TrackedTaskApiPingTrackedSleepTaskGetErrors, TrackedTaskApiPingTrackedSleepTaskGetResponses, TriggerImportApiImportsImportImportIdPostData, TriggerImportApiImportsImportImportIdPostErrors, TriggerImportApiImportsImportImportIdPostResponses, UpdateItemInfoApiItemInfoPutData, UpdateItemInfoApiItemInfoPutErrors, UpdateItemInfoApiItemInfoPutResponses, UpdateResolvedAnnotationsApiAnnotationsConfigResolveUpdatePutData, UpdateResolvedAnnotationsApiAnnotationsConfigResolveUpdatePutErrors, UpdateResolvedAnnotationsApiAnnotationsConfigResolveUpdatePutResponses, UpdateTrackerApiEvalTrackingRefreshPostData, UpdateTrackerApiEvalTrackingRefreshPostErrors, UpdateTrackerApiEvalTrackingRefreshPostResponses, UploadFileApiPipesArtefactsFilesUploadPostData, UploadFileApiPipesArtefactsFilesUploadPostErrors, UploadFileApiPipesArtefactsFilesUploadPostResponses, UploadFilesApiPipesArtefactsFilesUploadManyPostData, UploadFilesApiPipesArtefactsFilesUploadManyPostErrors, UploadFilesApiPipesArtefactsFilesUploadManyPostResponses, UpsertHighlighterApiHighlightersProjectPutData, UpsertHighlighterApiHighlightersProjectPutErrors, UpsertHighlighterApiHighlightersProjectPutResponses, WarnApiPingWarnGetData, WarnApiPingWarnGetResponses, WelcomeMailApiMailWelcomePostData, WelcomeMailApiMailWelcomePostErrors, WelcomeMailApiMailWelcomePostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class Default {
    /**
     * Tracked Task
     */
    public static trackedTaskApiPingTrackedSleepTaskGet<ThrowOnError extends boolean = true>(options?: Options<TrackedTaskApiPingTrackedSleepTaskGetData, ThrowOnError>) {
        return (options?.client ?? client).get<TrackedTaskApiPingTrackedSleepTaskGetResponses, TrackedTaskApiPingTrackedSleepTaskGetErrors, ThrowOnError>({ url: '/api/ping/tracked-sleep-task', ...options });
    }
    
    /**
     * Task
     */
    public static taskApiPingSleepTaskGet<ThrowOnError extends boolean = true>(options?: Options<TaskApiPingSleepTaskGetData, ThrowOnError>) {
        return (options?.client ?? client).get<TaskApiPingSleepTaskGetResponses, TaskApiPingSleepTaskGetErrors, ThrowOnError>({ url: '/api/ping/sleep-task', ...options });
    }
    
    /**
     *  Pong
     */
    public static pongApiPingGet<ThrowOnError extends boolean = true>(options?: Options<PongApiPingGetData, ThrowOnError>) {
        return (options?.client ?? client).get<PongApiPingGetResponses, unknown, ThrowOnError>({ url: '/api/ping/', ...options });
    }
    
    /**
     *  Err
     */
    public static errApiPingErrorGet<ThrowOnError extends boolean = true>(options?: Options<ErrApiPingErrorGetData, ThrowOnError>) {
        return (options?.client ?? client).get<ErrApiPingErrorGetResponses, unknown, ThrowOnError>({ url: '/api/ping/error', ...options });
    }
    
    /**
     *  Warn
     */
    public static warnApiPingWarnGet<ThrowOnError extends boolean = true>(options?: Options<WarnApiPingWarnGetData, ThrowOnError>) {
        return (options?.client ?? client).get<WarnApiPingWarnGetResponses, unknown, ThrowOnError>({ url: '/api/ping/warn', ...options });
    }
    
    /**
     * Perm
     */
    public static permApiPingPermissionGet<ThrowOnError extends boolean = true>(options?: Options<PermApiPingPermissionGetData, ThrowOnError>) {
        return (options?.client ?? client).get<PermApiPingPermissionGetResponses, unknown, ThrowOnError>({ url: '/api/ping/permission', ...options });
    }
    
    /**
     * Db Test
     */
    public static dbTestApiPingDatabaseGet<ThrowOnError extends boolean = true>(options?: Options<DbTestApiPingDatabaseGetData, ThrowOnError>) {
        return (options?.client ?? client).get<DbTestApiPingDatabaseGetResponses, unknown, ThrowOnError>({ url: '/api/ping/database', ...options });
    }
    
    /**
     *  Ping
     */
    public static pingApiPingNamePost<ThrowOnError extends boolean = true>(options: Options<PingApiPingNamePostData, ThrowOnError>) {
        return (options.client ?? client).post<PingApiPingNamePostResponses, PingApiPingNamePostErrors, ThrowOnError>({ url: '/api/ping/{name}', ...options });
    }
}

export class Annotations {
    /**
     * Get Scheme Definition
     *
     * This endpoint returns the detailed definition of an annotation scheme.
     *
     * :param annotation_scheme_id: database id of the annotation scheme.
     * :param flat: True to get the flattened scheme
     * :param permissions:
     * :return: a single annotation scheme
     */
    public static getSchemeDefinitionApiAnnotationsSchemesDefinitionAnnotationSchemeIdGet<ThrowOnError extends boolean = true>(options: Options<GetSchemeDefinitionApiAnnotationsSchemesDefinitionAnnotationSchemeIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetSchemeDefinitionApiAnnotationsSchemesDefinitionAnnotationSchemeIdGetResponses, GetSchemeDefinitionApiAnnotationsSchemesDefinitionAnnotationSchemeIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/schemes/definition/{annotation_scheme_id}',
            ...options
        });
    }
    
    /**
     * Put Annotation Scheme
     */
    public static putAnnotationSchemeApiAnnotationsSchemesDefinitionPut<ThrowOnError extends boolean = true>(options: Options<PutAnnotationSchemeApiAnnotationsSchemesDefinitionPutData, ThrowOnError>) {
        return (options.client ?? client).put<PutAnnotationSchemeApiAnnotationsSchemesDefinitionPutResponses, PutAnnotationSchemeApiAnnotationsSchemesDefinitionPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/schemes/definition/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Remove Annotation Scheme
     */
    public static removeAnnotationSchemeApiAnnotationsSchemesDefinitionSchemeIdDelete<ThrowOnError extends boolean = true>(options: Options<RemoveAnnotationSchemeApiAnnotationsSchemesDefinitionSchemeIdDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<RemoveAnnotationSchemeApiAnnotationsSchemesDefinitionSchemeIdDeleteResponses, RemoveAnnotationSchemeApiAnnotationsSchemesDefinitionSchemeIdDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/schemes/definition/{scheme_id}',
            ...options
        });
    }
    
    /**
     * Get Scheme Definitions For Project
     *
     * This endpoint returns the detailed definitions of all annotation schemes associated with a project.
     *
     * :param permissions:
     * :return: list of annotation schemes
     */
    public static getSchemeDefinitionsForProjectApiAnnotationsSchemesListGet<ThrowOnError extends boolean = true>(options: Options<GetSchemeDefinitionsForProjectApiAnnotationsSchemesListGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetSchemeDefinitionsForProjectApiAnnotationsSchemesListGetResponses, GetSchemeDefinitionsForProjectApiAnnotationsSchemesListGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/schemes/list',
            ...options
        });
    }
    
    /**
     * Get Annotation Scheme Fingerprints
     */
    public static getAnnotationSchemeFingerprintsApiAnnotationsSchemesFingerprintsGet<ThrowOnError extends boolean = true>(options: Options<GetAnnotationSchemeFingerprintsApiAnnotationsSchemesFingerprintsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAnnotationSchemeFingerprintsApiAnnotationsSchemesFingerprintsGetResponses, GetAnnotationSchemeFingerprintsApiAnnotationsSchemesFingerprintsGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/schemes/fingerprints',
            ...options
        });
    }
    
    /**
     * Get Next Assignment For Scope For User
     */
    public static getNextAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdCurrentAssignmentIdGet<ThrowOnError extends boolean = true>(options: Options<GetNextAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdCurrentAssignmentIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetNextAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdCurrentAssignmentIdGetResponses, GetNextAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdCurrentAssignmentIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/annotate/next/{assignment_scope_id}/{current_assignment_id}',
            ...options
        });
    }
    
    /**
     * Get Next Open Assignment For Scope For User
     */
    public static getNextOpenAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdGet<ThrowOnError extends boolean = true>(options: Options<GetNextOpenAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetNextOpenAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdGetResponses, GetNextOpenAssignmentForScopeForUserApiAnnotationsAnnotateNextAssignmentScopeIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/annotate/next/{assignment_scope_id}',
            ...options
        });
    }
    
    /**
     * Get Assignment
     */
    public static getAssignmentApiAnnotationsAnnotateAssignmentAssignmentIdGet<ThrowOnError extends boolean = true>(options: Options<GetAssignmentApiAnnotationsAnnotateAssignmentAssignmentIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAssignmentApiAnnotationsAnnotateAssignmentAssignmentIdGetResponses, GetAssignmentApiAnnotationsAnnotateAssignmentAssignmentIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/annotate/assignment/{assignment_id}',
            ...options
        });
    }
    
    /**
     * Get Assignment Scopes For User
     */
    public static getAssignmentScopesForUserApiAnnotationsAssignmentsScopesProjectIdGet<ThrowOnError extends boolean = true>(options: Options<GetAssignmentScopesForUserApiAnnotationsAssignmentsScopesProjectIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAssignmentScopesForUserApiAnnotationsAssignmentsScopesProjectIdGetResponses, GetAssignmentScopesForUserApiAnnotationsAssignmentsScopesProjectIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/assignments/scopes/{project_id}',
            ...options
        });
    }
    
    /**
     * Get Assignment Scopes For Project
     */
    public static getAssignmentScopesForProjectApiAnnotationsAssignmentsScopesGet<ThrowOnError extends boolean = true>(options: Options<GetAssignmentScopesForProjectApiAnnotationsAssignmentsScopesGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAssignmentScopesForProjectApiAnnotationsAssignmentsScopesGetResponses, GetAssignmentScopesForProjectApiAnnotationsAssignmentsScopesGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/assignments/scopes/',
            ...options
        });
    }
    
    /**
     * Get Assignment Scope
     */
    public static getAssignmentScopeApiAnnotationsAssignmentsScopeAssignmentScopeIdGet<ThrowOnError extends boolean = true>(options: Options<GetAssignmentScopeApiAnnotationsAssignmentsScopeAssignmentScopeIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAssignmentScopeApiAnnotationsAssignmentsScopeAssignmentScopeIdGetResponses, GetAssignmentScopeApiAnnotationsAssignmentsScopeAssignmentScopeIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/assignments/scope/{assignment_scope_id}',
            ...options
        });
    }
    
    /**
     * Put Assignment Scope
     */
    public static putAssignmentScopeApiAnnotationsAssignmentsScopePut<ThrowOnError extends boolean = true>(options: Options<PutAssignmentScopeApiAnnotationsAssignmentsScopePutData, ThrowOnError>) {
        return (options.client ?? client).put<PutAssignmentScopeApiAnnotationsAssignmentsScopePutResponses, PutAssignmentScopeApiAnnotationsAssignmentsScopePutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/assignments/scope/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Remove Assignment Scope
     */
    public static removeAssignmentScopeApiAnnotationsAnnotateScopeAssignmentScopeIdDelete<ThrowOnError extends boolean = true>(options: Options<RemoveAssignmentScopeApiAnnotationsAnnotateScopeAssignmentScopeIdDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<RemoveAssignmentScopeApiAnnotationsAnnotateScopeAssignmentScopeIdDeleteResponses, RemoveAssignmentScopeApiAnnotationsAnnotateScopeAssignmentScopeIdDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/annotate/scope/{assignment_scope_id}',
            ...options
        });
    }
    
    /**
     * Get Num Assignments For Scope
     */
    public static getNumAssignmentsForScopeApiAnnotationsAnnotateScopeCountsAssignmentScopeIdGet<ThrowOnError extends boolean = true>(options: Options<GetNumAssignmentsForScopeApiAnnotationsAnnotateScopeCountsAssignmentScopeIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetNumAssignmentsForScopeApiAnnotationsAnnotateScopeCountsAssignmentScopeIdGetResponses, GetNumAssignmentsForScopeApiAnnotationsAnnotateScopeCountsAssignmentScopeIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/annotate/scope/counts/{assignment_scope_id}',
            ...options
        });
    }
    
    /**
     * Get Assignments
     */
    public static getAssignmentsApiAnnotationsAnnotateAssignmentsAssignmentScopeIdGet<ThrowOnError extends boolean = true>(options: Options<GetAssignmentsApiAnnotationsAnnotateAssignmentsAssignmentScopeIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAssignmentsApiAnnotationsAnnotateAssignmentsAssignmentScopeIdGetResponses, GetAssignmentsApiAnnotationsAnnotateAssignmentsAssignmentScopeIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/annotate/assignments/{assignment_scope_id}',
            ...options
        });
    }
    
    /**
     * Get Assignment Indicators For Scope
     */
    public static getAssignmentIndicatorsForScopeApiAnnotationsAnnotateAssignmentProgressAssignmentScopeIdGet<ThrowOnError extends boolean = true>(options: Options<GetAssignmentIndicatorsForScopeApiAnnotationsAnnotateAssignmentProgressAssignmentScopeIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAssignmentIndicatorsForScopeApiAnnotationsAnnotateAssignmentProgressAssignmentScopeIdGetResponses, GetAssignmentIndicatorsForScopeApiAnnotationsAnnotateAssignmentProgressAssignmentScopeIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/annotate/assignment/progress/{assignment_scope_id}',
            ...options
        });
    }
    
    /**
     * Get Assignments For Scope
     */
    public static getAssignmentsForScopeApiAnnotationsAnnotateAssignmentsScopeAssignmentScopeIdGet<ThrowOnError extends boolean = true>(options: Options<GetAssignmentsForScopeApiAnnotationsAnnotateAssignmentsScopeAssignmentScopeIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAssignmentsForScopeApiAnnotationsAnnotateAssignmentsScopeAssignmentScopeIdGetResponses, GetAssignmentsForScopeApiAnnotationsAnnotateAssignmentsScopeAssignmentScopeIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/annotate/assignments/scope/{assignment_scope_id}',
            ...options
        });
    }
    
    /**
     * Get Annotations
     */
    public static getAnnotationsApiAnnotationsAnnotateAnnotationsAssignmentScopeIdGet<ThrowOnError extends boolean = true>(options: Options<GetAnnotationsApiAnnotationsAnnotateAnnotationsAssignmentScopeIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAnnotationsApiAnnotationsAnnotateAnnotationsAssignmentScopeIdGetResponses, GetAnnotationsApiAnnotationsAnnotateAnnotationsAssignmentScopeIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/annotate/annotations/{assignment_scope_id}',
            ...options
        });
    }
    
    /**
     * Save Annotation
     */
    public static saveAnnotationApiAnnotationsAnnotateSavePost<ThrowOnError extends boolean = true>(options: Options<SaveAnnotationApiAnnotationsAnnotateSavePostData, ThrowOnError>) {
        return (options.client ?? client).post<SaveAnnotationApiAnnotationsAnnotateSavePostResponses, SaveAnnotationApiAnnotationsAnnotateSavePostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/annotate/save',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Items With Count
     */
    public static getItemsWithCountApiAnnotationsConfigItemsGet<ThrowOnError extends boolean = true>(options: Options<GetItemsWithCountApiAnnotationsConfigItemsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetItemsWithCountApiAnnotationsConfigItemsGetResponses, GetItemsWithCountApiAnnotationsConfigItemsGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/config/items/',
            ...options
        });
    }
    
    /**
     * Make Assignments
     */
    public static makeAssignmentsApiAnnotationsConfigAssignmentsAssignmentScopeIdPut<ThrowOnError extends boolean = true>(options: Options<MakeAssignmentsApiAnnotationsConfigAssignmentsAssignmentScopeIdPutData, ThrowOnError>) {
        return (options.client ?? client).put<MakeAssignmentsApiAnnotationsConfigAssignmentsAssignmentScopeIdPutResponses, MakeAssignmentsApiAnnotationsConfigAssignmentsAssignmentScopeIdPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/config/assignments/{assignment_scope_id}',
            ...options
        });
    }
    
    /**
     * Clear Empty Assignments
     *
     * Drop all assignments in a scope that are still incomplete...
     *
     * :param scope_id:
     * :param user_id:
     * :param permissions:
     * :return:
     */
    public static clearEmptyAssignmentsApiAnnotationsConfigScopesClearSchemeIdPost<ThrowOnError extends boolean = true>(options: Options<ClearEmptyAssignmentsApiAnnotationsConfigScopesClearSchemeIdPostData, ThrowOnError>) {
        return (options.client ?? client).post<ClearEmptyAssignmentsApiAnnotationsConfigScopesClearSchemeIdPostResponses, ClearEmptyAssignmentsApiAnnotationsConfigScopesClearSchemeIdPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/config/scopes/clear/{scheme_id}',
            ...options
        });
    }
    
    /**
     * Bulk Add Assignment
     */
    public static bulkAddAssignmentApiAnnotationsConfigScopesBulkAddPut<ThrowOnError extends boolean = true>(options: Options<BulkAddAssignmentApiAnnotationsConfigScopesBulkAddPutData, ThrowOnError>) {
        return (options.client ?? client).put<BulkAddAssignmentApiAnnotationsConfigScopesBulkAddPutResponses, BulkAddAssignmentApiAnnotationsConfigScopesBulkAddPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/config/scopes/bulk-add/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Edit Assignment
     */
    public static editAssignmentApiAnnotationsConfigAssignmentsEditPut<ThrowOnError extends boolean = true>(options: Options<EditAssignmentApiAnnotationsConfigAssignmentsEditPutData, ThrowOnError>) {
        return (options.client ?? client).put<EditAssignmentApiAnnotationsConfigAssignmentsEditPutResponses, EditAssignmentApiAnnotationsConfigAssignmentsEditPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/config/assignments/edit/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Assignment Scopes For Scheme
     */
    public static getAssignmentScopesForSchemeApiAnnotationsConfigScopesSchemeIdGet<ThrowOnError extends boolean = true>(options: Options<GetAssignmentScopesForSchemeApiAnnotationsConfigScopesSchemeIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAssignmentScopesForSchemeApiAnnotationsConfigScopesSchemeIdGetResponses, GetAssignmentScopesForSchemeApiAnnotationsConfigScopesSchemeIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/config/scopes/{scheme_id}',
            ...options
        });
    }
    
    /**
     * Get Annotators For Scheme
     */
    public static getAnnotatorsForSchemeApiAnnotationsConfigAnnotatorsSchemeIdGet<ThrowOnError extends boolean = true>(options: Options<GetAnnotatorsForSchemeApiAnnotationsConfigAnnotatorsSchemeIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAnnotatorsForSchemeApiAnnotationsConfigAnnotatorsSchemeIdGetResponses, GetAnnotatorsForSchemeApiAnnotationsConfigAnnotatorsSchemeIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/config/annotators/{scheme_id}',
            ...options
        });
    }
    
    /**
     * Get Resolved Annotations
     *
     * Get all annotations that match the filters (e.g. all annotations made by users in scope with :scope_id).
     *
     * :param include_new:
     * :param update_existing:
     * :param assignment_scope_id:
     * :param bot_annotation_metadat_id:
     * :param include_empty:
     * :param settings
     * :param permissions:
     * :return:
     */
    public static getResolvedAnnotationsApiAnnotationsConfigResolvePost<ThrowOnError extends boolean = true>(options: Options<GetResolvedAnnotationsApiAnnotationsConfigResolvePostData, ThrowOnError>) {
        return (options.client ?? client).post<GetResolvedAnnotationsApiAnnotationsConfigResolvePostResponses, GetResolvedAnnotationsApiAnnotationsConfigResolvePostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/config/resolve',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Saved Resolved Annotations
     */
    public static getSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetadataIdGet<ThrowOnError extends boolean = true>(options: Options<GetSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetadataIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetadataIdGetResponses, GetSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetadataIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/config/resolved/{bot_annotation_metadata_id}',
            ...options
        });
    }
    
    /**
     * Save Resolved Annotations
     */
    public static saveResolvedAnnotationsApiAnnotationsConfigResolvePut<ThrowOnError extends boolean = true>(options: Options<SaveResolvedAnnotationsApiAnnotationsConfigResolvePutData, ThrowOnError>) {
        return (options.client ?? client).put<SaveResolvedAnnotationsApiAnnotationsConfigResolvePutResponses, SaveResolvedAnnotationsApiAnnotationsConfigResolvePutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/config/resolve/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update Resolved Annotations
     */
    public static updateResolvedAnnotationsApiAnnotationsConfigResolveUpdatePut<ThrowOnError extends boolean = true>(options: Options<UpdateResolvedAnnotationsApiAnnotationsConfigResolveUpdatePutData, ThrowOnError>) {
        return (options.client ?? client).put<UpdateResolvedAnnotationsApiAnnotationsConfigResolveUpdatePutResponses, UpdateResolvedAnnotationsApiAnnotationsConfigResolveUpdatePutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/config/resolve/update',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Saved Resolved Annotations
     */
    public static listSavedResolvedAnnotationsApiAnnotationsConfigResolvedListGet<ThrowOnError extends boolean = true>(options: Options<ListSavedResolvedAnnotationsApiAnnotationsConfigResolvedListGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListSavedResolvedAnnotationsApiAnnotationsConfigResolvedListGetResponses, ListSavedResolvedAnnotationsApiAnnotationsConfigResolvedListGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/config/resolved-list/',
            ...options
        });
    }
    
    /**
     * Delete Saved Resolved Annotations
     */
    public static deleteSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetaIdDelete<ThrowOnError extends boolean = true>(options: Options<DeleteSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetaIdDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetaIdDeleteResponses, DeleteSavedResolvedAnnotationsApiAnnotationsConfigResolvedBotAnnotationMetaIdDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/config/resolved/{bot_annotation_meta_id}',
            ...options
        });
    }
    
    /**
     * Get Bot Annotations
     */
    public static getBotAnnotationsApiAnnotationsBotAnnotationsGet<ThrowOnError extends boolean = true>(options: Options<GetBotAnnotationsApiAnnotationsBotAnnotationsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetBotAnnotationsApiAnnotationsBotAnnotationsGetResponses, GetBotAnnotationsApiAnnotationsBotAnnotationsGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/bot/annotations',
            ...options
        });
    }
    
    /**
     * Get Bot Scopes
     */
    public static getBotScopesApiAnnotationsBotScopesGet<ThrowOnError extends boolean = true>(options: Options<GetBotScopesApiAnnotationsBotScopesGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetBotScopesApiAnnotationsBotScopesGetResponses, GetBotScopesApiAnnotationsBotScopesGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/annotations/bot/scopes',
            ...options
        });
    }
}

export class Users {
    /**
     * Get All Users
     */
    public static getAllUsersApiUsersListAllGet<ThrowOnError extends boolean = true>(options?: Options<GetAllUsersApiUsersListAllGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetAllUsersApiUsersListAllGetResponses, unknown, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/users/list/all',
            ...options
        });
    }
    
    /**
     * Get All Users Dehydrated
     */
    public static getAllUsersDehydratedApiUsersListAllDehydratedGet<ThrowOnError extends boolean = true>(options?: Options<GetAllUsersDehydratedApiUsersListAllDehydratedGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetAllUsersDehydratedApiUsersListAllDehydratedGetResponses, unknown, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/users/list/all/dehydrated',
            ...options
        });
    }
    
    /**
     * Get Project Annotator Users
     */
    public static getProjectAnnotatorUsersApiUsersListProjectAnnotatorsProjectIdGet<ThrowOnError extends boolean = true>(options: Options<GetProjectAnnotatorUsersApiUsersListProjectAnnotatorsProjectIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetProjectAnnotatorUsersApiUsersListProjectAnnotatorsProjectIdGetResponses, GetProjectAnnotatorUsersApiUsersListProjectAnnotatorsProjectIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/users/list/project/annotators/{project_id}',
            ...options
        });
    }
    
    /**
     * Get Project Users
     */
    public static getProjectUsersApiUsersListProjectProjectIdGet<ThrowOnError extends boolean = true>(options: Options<GetProjectUsersApiUsersListProjectProjectIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetProjectUsersApiUsersListProjectProjectIdGetResponses, GetProjectUsersApiUsersListProjectProjectIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/users/list/project/{project_id}',
            ...options
        });
    }
    
    /**
     * Get User By Id
     */
    public static getUserByIdApiUsersDetailsUserIdGet<ThrowOnError extends boolean = true>(options: Options<GetUserByIdApiUsersDetailsUserIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetUserByIdApiUsersDetailsUserIdGetResponses, GetUserByIdApiUsersDetailsUserIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/users/details/{user_id}',
            ...options
        });
    }
    
    /**
     * Get Users By Ids
     */
    public static getUsersByIdsApiUsersDetailsGet<ThrowOnError extends boolean = true>(options: Options<GetUsersByIdsApiUsersDetailsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetUsersByIdsApiUsersDetailsGetResponses, GetUsersByIdsApiUsersDetailsGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/users/details',
            ...options
        });
    }
    
    /**
     * Save User
     */
    public static saveUserApiUsersDetailsPut<ThrowOnError extends boolean = true>(options: Options<SaveUserApiUsersDetailsPutData, ThrowOnError>) {
        return (options.client ?? client).put<SaveUserApiUsersDetailsPutResponses, SaveUserApiUsersDetailsPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/users/details',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Save User Self
     */
    public static saveUserSelfApiUsersMyDetailsPut<ThrowOnError extends boolean = true>(options: Options<SaveUserSelfApiUsersMyDetailsPutData, ThrowOnError>) {
        return (options.client ?? client).put<SaveUserSelfApiUsersMyDetailsPutResponses, SaveUserSelfApiUsersMyDetailsPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/users/my-details',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Oauth {
    /**
     * Login For Access Token
     */
    public static loginForAccessTokenApiLoginTokenPost<ThrowOnError extends boolean = true>(options: Options<LoginForAccessTokenApiLoginTokenPostData, ThrowOnError>) {
        return (options.client ?? client).post<LoginForAccessTokenApiLoginTokenPostResponses, LoginForAccessTokenApiLoginTokenPostErrors, ThrowOnError>({
            ...urlSearchParamsBodySerializer,
            url: '/api/login/token',
            ...options,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...options.headers
            }
        });
    }
    
    /**
     * Revoke Token
     */
    public static revokeTokenApiLoginTokenTokenIdDelete<ThrowOnError extends boolean = true>(options: Options<RevokeTokenApiLoginTokenTokenIdDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<RevokeTokenApiLoginTokenTokenIdDeleteResponses, RevokeTokenApiLoginTokenTokenIdDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/login/token/{token_id}',
            ...options
        });
    }
    
    /**
     * Refresh Token
     */
    public static refreshTokenApiLoginTokenTokenIdPut<ThrowOnError extends boolean = true>(options: Options<RefreshTokenApiLoginTokenTokenIdPutData, ThrowOnError>) {
        return (options.client ?? client).put<RefreshTokenApiLoginTokenTokenIdPutResponses, RefreshTokenApiLoginTokenTokenIdPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/login/token/{token_id}',
            ...options
        });
    }
    
    /**
     * Read Tokens Me
     */
    public static readTokensMeApiLoginMyTokensGet<ThrowOnError extends boolean = true>(options?: Options<ReadTokensMeApiLoginMyTokensGetData, ThrowOnError>) {
        return (options?.client ?? client).get<ReadTokensMeApiLoginMyTokensGetResponses, unknown, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/login/my-tokens',
            ...options
        });
    }
    
    /**
     * Read Users Me
     */
    public static readUsersMeApiLoginMeGet<ThrowOnError extends boolean = true>(options?: Options<ReadUsersMeApiLoginMeGetData, ThrowOnError>) {
        return (options?.client ?? client).get<ReadUsersMeApiLoginMeGetResponses, unknown, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/login/me',
            ...options
        });
    }
    
    /**
     * Logout
     */
    public static logoutApiLoginLogoutGet<ThrowOnError extends boolean = true>(options?: Options<LogoutApiLoginLogoutGetData, ThrowOnError>) {
        return (options?.client ?? client).get<LogoutApiLoginLogoutGetResponses, unknown, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/login/logout',
            ...options
        });
    }
}

export class Projects {
    /**
     * Get All Projects
     *
     * This endpoint returns all projects the currently logged-in user can see.
     * For regular users, this includes all projects for which an entry in ProjectPermissions exists.
     * For SuperUsers, this returns all projects on the platform.
     *
     * :return: List of projects
     */
    public static getAllProjectsApiProjectsListGet<ThrowOnError extends boolean = true>(options?: Options<GetAllProjectsApiProjectsListGetData, ThrowOnError>) {
        return (options?.client ?? client).get<GetAllProjectsApiProjectsListGetResponses, unknown, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/projects/list',
            ...options
        });
    }
    
    /**
     * Create Project
     */
    public static createProjectApiProjectsCreatePut<ThrowOnError extends boolean = true>(options: Options<CreateProjectApiProjectsCreatePutData, ThrowOnError>) {
        return (options.client ?? client).put<CreateProjectApiProjectsCreatePutResponses, CreateProjectApiProjectsCreatePutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/projects/create',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Project {
    /**
     * Get Project
     */
    public static getProjectApiProjectInfoGet<ThrowOnError extends boolean = true>(options: Options<GetProjectApiProjectInfoGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetProjectApiProjectInfoGetResponses, GetProjectApiProjectInfoGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/info',
            ...options
        });
    }
    
    /**
     * Save Project
     */
    public static saveProjectApiProjectInfoPut<ThrowOnError extends boolean = true>(options: Options<SaveProjectApiProjectInfoPutData, ThrowOnError>) {
        return (options.client ?? client).put<SaveProjectApiProjectInfoPutResponses, SaveProjectApiProjectInfoPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/info',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reset Import Mutex
     */
    public static resetImportMutexApiProjectImportMutexPut<ThrowOnError extends boolean = true>(options: Options<ResetImportMutexApiProjectImportMutexPutData, ThrowOnError>) {
        return (options.client ?? client).put<ResetImportMutexApiProjectImportMutexPutResponses, ResetImportMutexApiProjectImportMutexPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/import_mutex',
            ...options
        });
    }
    
    /**
     * Get Project Permissions Current User
     */
    public static getProjectPermissionsCurrentUserApiProjectPermissionsMeGet<ThrowOnError extends boolean = true>(options: Options<GetProjectPermissionsCurrentUserApiProjectPermissionsMeGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetProjectPermissionsCurrentUserApiProjectPermissionsMeGetResponses, GetProjectPermissionsCurrentUserApiProjectPermissionsMeGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/permissions/me',
            ...options
        });
    }
    
    /**
     * Get All Project Permissions
     */
    public static getAllProjectPermissionsApiProjectPermissionsListProjectIdGet<ThrowOnError extends boolean = true>(options: Options<GetAllProjectPermissionsApiProjectPermissionsListProjectIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAllProjectPermissionsApiProjectPermissionsListProjectIdGetResponses, GetAllProjectPermissionsApiProjectPermissionsListProjectIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/permissions/list/{project_id}',
            ...options
        });
    }
    
    /**
     * Get All User Permissions
     */
    public static getAllUserPermissionsApiProjectPermissionsListUsersGet<ThrowOnError extends boolean = true>(options: Options<GetAllUserPermissionsApiProjectPermissionsListUsersGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAllUserPermissionsApiProjectPermissionsListUsersGetResponses, GetAllUserPermissionsApiProjectPermissionsListUsersGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/permissions/list-users',
            ...options
        });
    }
    
    /**
     * Remove Project Permission
     */
    public static removeProjectPermissionApiProjectPermissionsPermissionDelete<ThrowOnError extends boolean = true>(options: Options<RemoveProjectPermissionApiProjectPermissionsPermissionDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<RemoveProjectPermissionApiProjectPermissionsPermissionDeleteResponses, RemoveProjectPermissionApiProjectPermissionsPermissionDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/permissions/permission',
            ...options
        });
    }
    
    /**
     * Save Project Permission
     */
    public static saveProjectPermissionApiProjectPermissionsPermissionPut<ThrowOnError extends boolean = true>(options: Options<SaveProjectPermissionApiProjectPermissionsPermissionPutData, ThrowOnError>) {
        return (options.client ?? client).put<SaveProjectPermissionApiProjectPermissionsPermissionPutResponses, SaveProjectPermissionApiProjectPermissionsPermissionPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/permissions/permission',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Project Permissions By Id
     */
    public static getProjectPermissionsByIdApiProjectPermissionsProjectPermissionIdGet<ThrowOnError extends boolean = true>(options: Options<GetProjectPermissionsByIdApiProjectPermissionsProjectPermissionIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetProjectPermissionsByIdApiProjectPermissionsProjectPermissionIdGetResponses, GetProjectPermissionsByIdApiProjectPermissionsProjectPermissionIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/permissions/{project_permission_id}',
            ...options
        });
    }
    
    /**
     * List Project Data
     */
    public static listProjectDataApiProjectItemsItemTypeListGet<ThrowOnError extends boolean = true>(options: Options<ListProjectDataApiProjectItemsItemTypeListGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListProjectDataApiProjectItemsItemTypeListGetResponses, ListProjectDataApiProjectItemsItemTypeListGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/items/{item_type}/list',
            ...options
        });
    }
    
    /**
     * List Project Data Paged
     */
    public static listProjectDataPagedApiProjectItemsItemTypeListPagePageSizeGet<ThrowOnError extends boolean = true>(options: Options<ListProjectDataPagedApiProjectItemsItemTypeListPagePageSizeGetData, ThrowOnError>) {
        return (options.client ?? client).get<ListProjectDataPagedApiProjectItemsItemTypeListPagePageSizeGetResponses, ListProjectDataPagedApiProjectItemsItemTypeListPagePageSizeGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/items/{item_type}/list/{page}/{page_size}',
            ...options
        });
    }
    
    /**
     * Get Detail For Item
     */
    public static getDetailForItemApiProjectItemsDetailItemIdGet<ThrowOnError extends boolean = true>(options: Options<GetDetailForItemApiProjectItemsDetailItemIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetDetailForItemApiProjectItemsDetailItemIdGetResponses, GetDetailForItemApiProjectItemsDetailItemIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/items/detail/{item_id}',
            ...options
        });
    }
    
    /**
     * Get Text For Item
     */
    public static getTextForItemApiProjectItemsTextItemIdGet<ThrowOnError extends boolean = true>(options: Options<GetTextForItemApiProjectItemsTextItemIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetTextForItemApiProjectItemsTextItemIdGetResponses, GetTextForItemApiProjectItemsTextItemIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/items/text/{item_id}',
            ...options
        });
    }
    
    /**
     * Count Project Items
     */
    public static countProjectItemsApiProjectItemsCountGet<ThrowOnError extends boolean = true>(options: Options<CountProjectItemsApiProjectItemsCountGetData, ThrowOnError>) {
        return (options.client ?? client).get<CountProjectItemsApiProjectItemsCountGetResponses, CountProjectItemsApiProjectItemsCountGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/items/count',
            ...options
        });
    }
    
    /**
     * Add Tweet
     */
    public static addTweetApiProjectItemsTwitterAddPost<ThrowOnError extends boolean = true>(options: Options<AddTweetApiProjectItemsTwitterAddPostData, ThrowOnError>) {
        return (options.client ?? client).post<AddTweetApiProjectItemsTwitterAddPostResponses, AddTweetApiProjectItemsTwitterAddPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/project/items/twitter/add',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Imports {
    /**
     * Get All Imports For Project
     */
    public static getAllImportsForProjectApiImportsListGet<ThrowOnError extends boolean = true>(options: Options<GetAllImportsForProjectApiImportsListGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAllImportsForProjectApiImportsListGetResponses, GetAllImportsForProjectApiImportsListGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/imports/list',
            ...options
        });
    }
    
    /**
     * Get Project Imports
     */
    public static getProjectImportsApiImportsListDetailsGet<ThrowOnError extends boolean = true>(options: Options<GetProjectImportsApiImportsListDetailsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetProjectImportsApiImportsListDetailsGetResponses, GetProjectImportsApiImportsListDetailsGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/imports/list/details',
            ...options
        });
    }
    
    /**
     * Get Import Details
     */
    public static getImportDetailsApiImportsImportImportIdGet<ThrowOnError extends boolean = true>(options: Options<GetImportDetailsApiImportsImportImportIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetImportDetailsApiImportsImportImportIdGetResponses, GetImportDetailsApiImportsImportImportIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/imports/import/{import_id}',
            ...options
        });
    }
    
    /**
     * Trigger Import
     */
    public static triggerImportApiImportsImportImportIdPost<ThrowOnError extends boolean = true>(options: Options<TriggerImportApiImportsImportImportIdPostData, ThrowOnError>) {
        return (options.client ?? client).post<TriggerImportApiImportsImportImportIdPostResponses, TriggerImportApiImportsImportImportIdPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/imports/import/{import_id}',
            ...options
        });
    }
    
    /**
     * Get Import Counts
     */
    public static getImportCountsApiImportsImportImportIdCountGet<ThrowOnError extends boolean = true>(options: Options<GetImportCountsApiImportsImportImportIdCountGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetImportCountsApiImportsImportImportIdCountGetResponses, GetImportCountsApiImportsImportImportIdCountGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/imports/import/{import_id}/count/',
            ...options
        });
    }
    
    /**
     * Get Import Revisions
     */
    public static getImportRevisionsApiImportsImportImportIdRevisionsGet<ThrowOnError extends boolean = true>(options: Options<GetImportRevisionsApiImportsImportImportIdRevisionsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetImportRevisionsApiImportsImportImportIdRevisionsGetResponses, GetImportRevisionsApiImportsImportImportIdRevisionsGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/imports/import/{import_id}/revisions',
            ...options
        });
    }
    
    /**
     * Put Import Details
     */
    public static putImportDetailsApiImportsImportPut<ThrowOnError extends boolean = true>(options: Options<PutImportDetailsApiImportsImportPutData, ThrowOnError>) {
        return (options.client ?? client).put<PutImportDetailsApiImportsImportPutResponses, PutImportDetailsApiImportsImportPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/imports/import',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Import Details
     */
    public static deleteImportDetailsApiImportsImportDeleteImportIdDelete<ThrowOnError extends boolean = true>(options: Options<DeleteImportDetailsApiImportsImportDeleteImportIdDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteImportDetailsApiImportsImportDeleteImportIdDeleteResponses, DeleteImportDetailsApiImportsImportDeleteImportIdDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/imports/import/delete/{import_id}',
            ...options
        });
    }
}

export class Events {
    /**
     * Emit
     *
     * This route can be used to trigger an event on the system.
     * FIXME: This should require some sort of authentication!
     *
     * :param event: event (incl optional payload) to emit
     * :return: void
     */
    public static emitApiEventsEmitPost<ThrowOnError extends boolean = true>(options: Options<EmitApiEventsEmitPostData, ThrowOnError>) {
        return (options.client ?? client).post<EmitApiEventsEmitPostResponses, EmitApiEventsEmitPostErrors, ThrowOnError>({
            url: '/api/events/emit',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Highlighters {
    /**
     * Get Project Highlighters
     */
    public static getProjectHighlightersApiHighlightersProjectGet<ThrowOnError extends boolean = true>(options: Options<GetProjectHighlightersApiHighlightersProjectGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetProjectHighlightersApiHighlightersProjectGetResponses, GetProjectHighlightersApiHighlightersProjectGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/highlighters/project',
            ...options
        });
    }
    
    /**
     * Upsert Highlighter
     */
    public static upsertHighlighterApiHighlightersProjectPut<ThrowOnError extends boolean = true>(options: Options<UpsertHighlighterApiHighlightersProjectPutData, ThrowOnError>) {
        return (options.client ?? client).put<UpsertHighlighterApiHighlightersProjectPutResponses, UpsertHighlighterApiHighlightersProjectPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/highlighters/project',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Highlighter
     */
    public static getHighlighterApiHighlightersHighlighterIdGet<ThrowOnError extends boolean = true>(options: Options<GetHighlighterApiHighlightersHighlighterIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetHighlighterApiHighlightersHighlighterIdGetResponses, GetHighlighterApiHighlightersHighlighterIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/highlighters/{highlighter_id}',
            ...options
        });
    }
}

export class Stats {
    /**
     * Get Basic Stats
     */
    public static getBasicStatsApiStatsBasicsGet<ThrowOnError extends boolean = true>(options: Options<GetBasicStatsApiStatsBasicsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetBasicStatsApiStatsBasicsGetResponses, GetBasicStatsApiStatsBasicsGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/stats/basics',
            ...options
        });
    }
    
    /**
     * Get Annotator Ranking
     */
    public static getAnnotatorRankingApiStatsRankGet<ThrowOnError extends boolean = true>(options: Options<GetAnnotatorRankingApiStatsRankGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetAnnotatorRankingApiStatsRankGetResponses, GetAnnotatorRankingApiStatsRankGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/stats/rank',
            ...options
        });
    }
    
    /**
     * Get Publication Year Histogram
     */
    public static getPublicationYearHistogramApiStatsHistogramYearsGet<ThrowOnError extends boolean = true>(options: Options<GetPublicationYearHistogramApiStatsHistogramYearsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetPublicationYearHistogramApiStatsHistogramYearsGetResponses, GetPublicationYearHistogramApiStatsHistogramYearsGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/stats/histogram/years',
            ...options
        });
    }
    
    /**
     * Label Stats
     */
    public static labelStatsApiStatsLabelsHumanPost<ThrowOnError extends boolean = true>(options: Options<LabelStatsApiStatsLabelsHumanPostData, ThrowOnError>) {
        return (options.client ?? client).post<LabelStatsApiStatsLabelsHumanPostResponses, LabelStatsApiStatsLabelsHumanPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/stats/labels/human',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Label Stats
     */
    public static labelStatsApiStatsLabelsResolvedPost<ThrowOnError extends boolean = true>(options: Options<LabelStatsApiStatsLabelsResolvedPostData, ThrowOnError>) {
        return (options.client ?? client).post<LabelStatsApiStatsLabelsResolvedPostResponses, LabelStatsApiStatsLabelsResolvedPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/stats/labels/resolved',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Export {
    /**
     * Get Annotations Csv
     */
    public static getAnnotationsCsvApiExportAnnotationsCsvPost<ThrowOnError extends boolean = true>(options: Options<GetAnnotationsCsvApiExportAnnotationsCsvPostData, ThrowOnError>) {
        return (options.client ?? client).post<GetAnnotationsCsvApiExportAnnotationsCsvPostResponses, GetAnnotationsCsvApiExportAnnotationsCsvPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/export/annotations/csv',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Export Baseinfo
     */
    public static getExportBaseinfoApiExportProjectBaseinfoGet<ThrowOnError extends boolean = true>(options: Options<GetExportBaseinfoApiExportProjectBaseinfoGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetExportBaseinfoApiExportProjectBaseinfoGetResponses, GetExportBaseinfoApiExportProjectBaseinfoGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/export/project/baseinfo',
            ...options
        });
    }
}

export class Search {
    /**
     * Search Openalex
     */
    public static searchOpenalexApiSearchOpenalexSelectPost<ThrowOnError extends boolean = true>(options: Options<SearchOpenalexApiSearchOpenalexSelectPostData, ThrowOnError>) {
        return (options.client ?? client).post<SearchOpenalexApiSearchOpenalexSelectPostResponses, SearchOpenalexApiSearchOpenalexSelectPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/search/openalex/select',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Term Expansion
     */
    public static termExpansionApiSearchOpenalexTermsGet<ThrowOnError extends boolean = true>(options: Options<TermExpansionApiSearchOpenalexTermsGetData, ThrowOnError>) {
        return (options.client ?? client).get<TermExpansionApiSearchOpenalexTermsGetResponses, TermExpansionApiSearchOpenalexTermsGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/search/openalex/terms',
            ...options
        });
    }
    
    /**
     * Nql Query
     */
    public static nqlQueryApiSearchNqlQueryPost<ThrowOnError extends boolean = true>(options: Options<NqlQueryApiSearchNqlQueryPostData, ThrowOnError>) {
        return (options.client ?? client).post<NqlQueryApiSearchNqlQueryPostResponses, NqlQueryApiSearchNqlQueryPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/search/nql/query',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Nql Query Count
     */
    public static nqlQueryCountApiSearchNqlCountPost<ThrowOnError extends boolean = true>(options: Options<NqlQueryCountApiSearchNqlCountPostData, ThrowOnError>) {
        return (options.client ?? client).post<NqlQueryCountApiSearchNqlCountPostResponses, NqlQueryCountApiSearchNqlCountPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/search/nql/count',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Evaluation {
    /**
     * Get Project Scopes
     */
    public static getProjectScopesApiEvalTrackingScopesGet<ThrowOnError extends boolean = true>(options: Options<GetProjectScopesApiEvalTrackingScopesGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetProjectScopesApiEvalTrackingScopesGetResponses, GetProjectScopesApiEvalTrackingScopesGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eval/tracking/scopes',
            ...options
        });
    }
    
    /**
     * Get Resolutions For Scope
     */
    public static getResolutionsForScopeApiEvalResolutionsGet<ThrowOnError extends boolean = true>(options: Options<GetResolutionsForScopeApiEvalResolutionsGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetResolutionsForScopeApiEvalResolutionsGetResponses, GetResolutionsForScopeApiEvalResolutionsGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eval/resolutions',
            ...options
        });
    }
    
    /**
     * Get Project Trackers
     */
    public static getProjectTrackersApiEvalTrackingTrackersGet<ThrowOnError extends boolean = true>(options: Options<GetProjectTrackersApiEvalTrackingTrackersGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetProjectTrackersApiEvalTrackingTrackersGetResponses, GetProjectTrackersApiEvalTrackingTrackersGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eval/tracking/trackers',
            ...options
        });
    }
    
    /**
     * Get Tracker
     */
    public static getTrackerApiEvalTrackingTrackerTrackerIdGet<ThrowOnError extends boolean = true>(options: Options<GetTrackerApiEvalTrackingTrackerTrackerIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetTrackerApiEvalTrackingTrackerTrackerIdGetResponses, GetTrackerApiEvalTrackingTrackerTrackerIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eval/tracking/tracker/{tracker_id}',
            ...options
        });
    }
    
    /**
     * Save Tracker
     */
    public static saveTrackerApiEvalTrackingTrackerPut<ThrowOnError extends boolean = true>(options: Options<SaveTrackerApiEvalTrackingTrackerPutData, ThrowOnError>) {
        return (options.client ?? client).put<SaveTrackerApiEvalTrackingTrackerPutResponses, SaveTrackerApiEvalTrackingTrackerPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eval/tracking/tracker',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update Tracker
     */
    public static updateTrackerApiEvalTrackingRefreshPost<ThrowOnError extends boolean = true>(options: Options<UpdateTrackerApiEvalTrackingRefreshPostData, ThrowOnError>) {
        return (options.client ?? client).post<UpdateTrackerApiEvalTrackingRefreshPostResponses, UpdateTrackerApiEvalTrackingRefreshPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eval/tracking/refresh',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Irr
     */
    public static getIrrApiEvalQualityLoadAssignmentScopeIdGet<ThrowOnError extends boolean = true>(options: Options<GetIrrApiEvalQualityLoadAssignmentScopeIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetIrrApiEvalQualityLoadAssignmentScopeIdGetResponses, GetIrrApiEvalQualityLoadAssignmentScopeIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eval/quality/load/{assignment_scope_id}',
            ...options
        });
    }
    
    /**
     * Recompute Irr
     */
    public static recomputeIrrApiEvalQualityComputeGet<ThrowOnError extends boolean = true>(options: Options<RecomputeIrrApiEvalQualityComputeGetData, ThrowOnError>) {
        return (options.client ?? client).get<RecomputeIrrApiEvalQualityComputeGetResponses, RecomputeIrrApiEvalQualityComputeGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eval/quality/compute',
            ...options
        });
    }
}

export class Mailing {
    /**
     * Reset Password
     */
    public static resetPasswordApiMailResetPasswordUsernamePost<ThrowOnError extends boolean = true>(options: Options<ResetPasswordApiMailResetPasswordUsernamePostData, ThrowOnError>) {
        return (options.client ?? client).post<ResetPasswordApiMailResetPasswordUsernamePostResponses, ResetPasswordApiMailResetPasswordUsernamePostErrors, ThrowOnError>({ url: '/api/mail/reset-password/{username}', ...options });
    }
    
    /**
     * Welcome Mail
     */
    public static welcomeMailApiMailWelcomePost<ThrowOnError extends boolean = true>(options: Options<WelcomeMailApiMailWelcomePostData, ThrowOnError>) {
        return (options.client ?? client).post<WelcomeMailApiMailWelcomePostResponses, WelcomeMailApiMailWelcomePostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/mail/welcome',
            ...options
        });
    }
    
    /**
     * Remind Users Assigment
     */
    public static remindUsersAssigmentApiMailAssignmentReminderPost<ThrowOnError extends boolean = true>(options: Options<RemindUsersAssigmentApiMailAssignmentReminderPostData, ThrowOnError>) {
        return (options.client ?? client).post<RemindUsersAssigmentApiMailAssignmentReminderPostResponses, RemindUsersAssigmentApiMailAssignmentReminderPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/mail/assignment-reminder',
            ...options
        });
    }
    
    /**
     * News Mail
     */
    public static newsMailApiMailNewsPost<ThrowOnError extends boolean = true>(options: Options<NewsMailApiMailNewsPostData, ThrowOnError>) {
        return (options.client ?? client).post<NewsMailApiMailNewsPostResponses, NewsMailApiMailNewsPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/mail/news',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Pipes {
    /**
     * Get Artefacts
     */
    public static getArtefactsApiPipesArtefactsListGet<ThrowOnError extends boolean = true>(options: Options<GetArtefactsApiPipesArtefactsListGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetArtefactsApiPipesArtefactsListGetResponses, GetArtefactsApiPipesArtefactsListGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/pipes/artefacts/list',
            ...options
        });
    }
    
    /**
     * Get Task Log
     */
    public static getTaskLogApiPipesArtefactsLogGet<ThrowOnError extends boolean = true>(options: Options<GetTaskLogApiPipesArtefactsLogGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetTaskLogApiPipesArtefactsLogGetResponses, GetTaskLogApiPipesArtefactsLogGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/pipes/artefacts/log',
            ...options
        });
    }
    
    /**
     * Stream Task Log
     */
    public static streamTaskLogApiPipesArtefactsLogStreamGet<ThrowOnError extends boolean = true>(options: Options<StreamTaskLogApiPipesArtefactsLogStreamGetData, ThrowOnError>) {
        return (options.client ?? client).get<StreamTaskLogApiPipesArtefactsLogStreamGetResponses, StreamTaskLogApiPipesArtefactsLogStreamGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/pipes/artefacts/log-stream',
            ...options
        });
    }
    
    /**
     * Get File
     */
    public static getFileApiPipesArtefactsFileGet<ThrowOnError extends boolean = true>(options: Options<GetFileApiPipesArtefactsFileGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetFileApiPipesArtefactsFileGetResponses, GetFileApiPipesArtefactsFileGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/pipes/artefacts/file',
            ...options
        });
    }
    
    /**
     * Get Archive
     */
    public static getArchiveApiPipesArtefactsFilesGet<ThrowOnError extends boolean = true>(options: Options<GetArchiveApiPipesArtefactsFilesGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetArchiveApiPipesArtefactsFilesGetResponses, GetArchiveApiPipesArtefactsFilesGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/pipes/artefacts/files',
            ...options
        });
    }
    
    /**
     * Upload File
     */
    public static uploadFileApiPipesArtefactsFilesUploadPost<ThrowOnError extends boolean = true>(options: Options<UploadFileApiPipesArtefactsFilesUploadPostData, ThrowOnError>) {
        return (options.client ?? client).post<UploadFileApiPipesArtefactsFilesUploadPostResponses, UploadFileApiPipesArtefactsFilesUploadPostErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/pipes/artefacts/files/upload',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Upload Files
     */
    public static uploadFilesApiPipesArtefactsFilesUploadManyPost<ThrowOnError extends boolean = true>(options: Options<UploadFilesApiPipesArtefactsFilesUploadManyPostData, ThrowOnError>) {
        return (options.client ?? client).post<UploadFilesApiPipesArtefactsFilesUploadManyPostResponses, UploadFilesApiPipesArtefactsFilesUploadManyPostErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/pipes/artefacts/files/upload-many',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Search Tasks
     */
    public static searchTasksApiPipesTasksGet<ThrowOnError extends boolean = true>(options: Options<SearchTasksApiPipesTasksGetData, ThrowOnError>) {
        return (options.client ?? client).get<SearchTasksApiPipesTasksGetResponses, SearchTasksApiPipesTasksGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/pipes/tasks',
            ...options
        });
    }
    
    /**
     * Delete Task
     */
    public static deleteTaskApiPipesTaskDelete<ThrowOnError extends boolean = true>(options: Options<DeleteTaskApiPipesTaskDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteTaskApiPipesTaskDeleteResponses, DeleteTaskApiPipesTaskDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/pipes/task',
            ...options
        });
    }
    
    /**
     * Get Task
     */
    public static getTaskApiPipesTaskGet<ThrowOnError extends boolean = true>(options: Options<GetTaskApiPipesTaskGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetTaskApiPipesTaskGetResponses, GetTaskApiPipesTaskGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/pipes/task',
            ...options
        });
    }
    
    /**
     * Terminate Task
     */
    public static terminateTaskApiPipesDramatiqTaskDelete<ThrowOnError extends boolean = true>(options: Options<TerminateTaskApiPipesDramatiqTaskDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<TerminateTaskApiPipesDramatiqTaskDeleteResponses, TerminateTaskApiPipesDramatiqTaskDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/pipes/dramatiq/task',
            ...options
        });
    }
}

export class Item {
    /**
     * Get Item Variants
     */
    public static getItemVariantsApiItemVariantsItemIdGet<ThrowOnError extends boolean = true>(options: Options<GetItemVariantsApiItemVariantsItemIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetItemVariantsApiItemVariantsItemIdGetResponses, GetItemVariantsApiItemVariantsItemIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/item/variants/{item_id}',
            ...options
        });
    }
    
    /**
     * Get Item Info
     */
    public static getItemInfoApiItemInfoItemIdGet<ThrowOnError extends boolean = true>(options: Options<GetItemInfoApiItemInfoItemIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetItemInfoApiItemInfoItemIdGetResponses, GetItemInfoApiItemInfoItemIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/item/info/{item_id}',
            ...options
        });
    }
    
    /**
     * Get Item M2Ms
     */
    public static getItemM2MsApiItemM2MsItemIdGet<ThrowOnError extends boolean = true>(options: Options<GetItemM2MsApiItemM2MsItemIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetItemM2MsApiItemM2MsItemIdGetResponses, GetItemM2MsApiItemM2MsItemIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/item/m2ms/{item_id}',
            ...options
        });
    }
    
    /**
     * Get Item Labels
     */
    public static getItemLabelsApiItemLabelsItemIdGet<ThrowOnError extends boolean = true>(options: Options<GetItemLabelsApiItemLabelsItemIdGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetItemLabelsApiItemLabelsItemIdGetResponses, GetItemLabelsApiItemLabelsItemIdGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/item/labels/{item_id}',
            ...options
        });
    }
    
    /**
     * Update Item Info
     */
    public static updateItemInfoApiItemInfoPut<ThrowOnError extends boolean = true>(options: Options<UpdateItemInfoApiItemInfoPutData, ThrowOnError>) {
        return (options.client ?? client).put<UpdateItemInfoApiItemInfoPutResponses, UpdateItemInfoApiItemInfoPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/item/info',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Prio {
    /**
     * Get Table Sample Html
     */
    public static getTableSampleHtmlApiPrioTablePeekHtmlPost<ThrowOnError extends boolean = true>(options: Options<GetTableSampleHtmlApiPrioTablePeekHtmlPostData, ThrowOnError>) {
        return (options.client ?? client).post<GetTableSampleHtmlApiPrioTablePeekHtmlPostResponses, GetTableSampleHtmlApiPrioTablePeekHtmlPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/prio/table/peek/html',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Table Sample
     */
    public static getTableSampleApiPrioTablePeekPost<ThrowOnError extends boolean = true>(options: Options<GetTableSampleApiPrioTablePeekPostData, ThrowOnError>) {
        return (options.client ?? client).post<GetTableSampleApiPrioTablePeekPostResponses, GetTableSampleApiPrioTablePeekPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/prio/table/peek',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Read Project Setups
     */
    public static readProjectSetupsApiPrioSetupsGet<ThrowOnError extends boolean = true>(options: Options<ReadProjectSetupsApiPrioSetupsGetData, ThrowOnError>) {
        return (options.client ?? client).get<ReadProjectSetupsApiPrioSetupsGetResponses, ReadProjectSetupsApiPrioSetupsGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/prio/setups',
            ...options
        });
    }
    
    /**
     * Drop Prio Setup
     */
    public static dropPrioSetupApiPrioSetupDelete<ThrowOnError extends boolean = true>(options: Options<DropPrioSetupApiPrioSetupDeleteData, ThrowOnError>) {
        return (options.client ?? client).delete<DropPrioSetupApiPrioSetupDeleteResponses, DropPrioSetupApiPrioSetupDeleteErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/prio/setup',
            ...options
        });
    }
    
    /**
     * Read Prio Setup
     */
    public static readPrioSetupApiPrioSetupGet<ThrowOnError extends boolean = true>(options: Options<ReadPrioSetupApiPrioSetupGetData, ThrowOnError>) {
        return (options.client ?? client).get<ReadPrioSetupApiPrioSetupGetResponses, ReadPrioSetupApiPrioSetupGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/prio/setup',
            ...options
        });
    }
    
    /**
     * Save Prio Setup
     */
    public static savePrioSetupApiPrioSetupPut<ThrowOnError extends boolean = true>(options: Options<SavePrioSetupApiPrioSetupPutData, ThrowOnError>) {
        return (options.client ?? client).put<SavePrioSetupApiPrioSetupPutResponses, SavePrioSetupApiPrioSetupPutErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/prio/setup',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Artefacts
     */
    public static getArtefactsApiPrioArtefactsListGet<ThrowOnError extends boolean = true>(options: Options<GetArtefactsApiPrioArtefactsListGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetArtefactsApiPrioArtefactsListGetResponses, GetArtefactsApiPrioArtefactsListGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/prio/artefacts/list',
            ...options
        });
    }
    
    /**
     * Get File
     */
    public static getFileApiPrioArtefactsFileGet<ThrowOnError extends boolean = true>(options: Options<GetFileApiPrioArtefactsFileGetData, ThrowOnError>) {
        return (options.client ?? client).get<GetFileApiPrioArtefactsFileGetResponses, GetFileApiPrioArtefactsFileGetErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/prio/artefacts/file',
            ...options
        });
    }
}
